// src/components/ItemInfo.tsx
import { DataBox } from "@/components/molecule/dataBox/DataBox";
import { itemTypeColor, itemTypeObj } from "@/constants/items";
import { COMMON_TEXT } from "@/constants/text";
import { useWorkDataStore } from "@/store/work.store";
import { getWorkTrackingStatus } from "@/utils/tranferWorkStatus";
import { Badge, Flex, Text } from "@mantine/core";

export const ItemInfoBox = () => {
  const { workData } = useWorkDataStore((state) => ({
    workData: state.workData,
  }));
  const { work } = workData;

  const { itemWithGrade, trackingStatus, item, productionPlan, equipmentName } =
    work ?? {};
  const { code, name, itemType } = item ?? {};
  const { presetLotName } = productionPlan ?? {};
  const { unitText, gradeName, itemCategoryName, abstractItemCode } =
    itemWithGrade ?? {};

  return (
    <Flex wrap="wrap" bg={"#212529"} direction={"column"} p={"md"}>
      <Flex w="100%">
        <DataBox
          label={COMMON_TEXT.LABEL.CURRENT_WORK_STATUS}
          data={
            <Badge
              color={getWorkTrackingStatus(trackingStatus).color}
              size="lg"
            >
              {getWorkTrackingStatus(trackingStatus).status}
            </Badge>
          }
        />
        <DataBox
          label={COMMON_TEXT.LABEL.LOT_NAME}
          data={<Text>{presetLotName}</Text>}
        />
        <DataBox
          label={COMMON_TEXT.LABEL.ITEM_CATEGORY}
          data={
            <Badge
              size="lg"
              color={itemTypeColor[itemType as keyof typeof itemTypeColor]}
            >
              {itemTypeObj[itemType!]}
            </Badge>
          }
        />
        <DataBox label={COMMON_TEXT.LABEL.ITEM_NAME} data={name ?? "-"} />
      </Flex>
      <Flex w="100%">
        <DataBox
          label={COMMON_TEXT.COLUMN.EQUIPMENT_NAME}
          data={<Text>{equipmentName}</Text>}
        />
        <DataBox
          label={COMMON_TEXT.COLUMN.ITEM_CODE}
          data={<Text>{code}</Text>}
        />
      </Flex>
      <Flex w="100%">
        <DataBox label={COMMON_TEXT.LABEL.GRADE} data={gradeName ?? "-"} />
        <DataBox
          label={COMMON_TEXT.LABEL.COLOR}
          data={itemCategoryName ?? "-"}
        />
        <DataBox
          label={COMMON_TEXT.LABEL.SHAPE}
          data={abstractItemCode ?? "-"}
        />
        {/* <DataBox label={COMMON_TEXT.LABEL.DEPTH} data={depth ?? "-"} /> */}
        <DataBox label={COMMON_TEXT.LABEL.UNIT} data={unitText ?? "-"} />
      </Flex>
    </Flex>
  );
};
